<template>
  <svg xmlns="http://www.w3.org/2000/svg" :viewBox="viewBox" width="100%" height="100%">
    <g >
      <slot />
    </g>
  </svg>
</template>

<script>
  export default {
    props: {
      viewBox: {
        type: String,
        default: '0 0 10 10',
      },
    }
  }
</script>

<style scoped>
  svg {
    /*display: inline-block;*/
    vertical-align: baseline;
    /*margin-bottom: -2px; !* yes, I'm that particular about formatting *!*/
  }
</style>
